import styled from 'styled-components';
import { AVATAR_SIZES } from 'ui/avatar';
import { Body2 } from 'ui/theme';
import { ContactCard } from '../types';
import { getContactCardAvatar } from '../utils';
import { ContactCardListEntryWrapper, PhoneNumberDisplay } from './ContactCards.styles';

const DisplayNameWrapper = styled(Body2)`
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const ContactCardListEntry = ({
  className = '',
  asset,
  onClick,
}: {
  className?: string;
  asset: ContactCard;
  onClick: () => void;
}) => {
  return (
    <ContactCardListEntryWrapper
      onClick={onClick}
      className={className}
      data-test="contact-card-list-entry"
    >
      {getContactCardAvatar(asset, AVATAR_SIZES.MEDIUM)}
      <div>
        <DisplayNameWrapper>{asset.displayName}</DisplayNameWrapper>
        <PhoneNumberDisplay>{asset.smsSender.name}</PhoneNumberDisplay>
      </div>
    </ContactCardListEntryWrapper>
  );
};
